export const getSelectedEnvironment = (state, _) =>
  state.onboarding.environment.selectedEnvironment;
